export default {"src":"/_next/static/media/promotion.991174f5.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};